<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="dealer-view">
    <div class="data">
      <h1>Asignar vendedores a sucursal</h1>
      <ms-form-filter
        :filters="filters"
        default-search="username"/>
      <ms-grid
        :data="users"
        :columns="columns"
        :options="options"
        :pager="pager">
        <template
          slot="role"
          slot-scope="{row}">
          <span>{{ parseRole(row.role) }}</span>
        </template>
        <template slot="no-content">
          <div class="no-content">
            <i class="icon-alert-triangle"/>
            <h1>No se encontraron resultados</h1>
            <h5>Solicite a sus Gerentes de Sucursal y Vendedores que accedan al sistema para poder asignarlos</h5>
          </div>
        </template>
      </ms-grid>
    </div>
    <form-modal
      v-if="showModal"
      @closeModal="() => { showModal = false }">
      <div class="modal-content">
        <el-form
          ref="assignForm"
          @submit.native.prevent="onSubmitAssign">
          <el-form-item label="Sucursal">
            <el-select
              v-model="assign"
              style="width: 100%;"
              placeholder="Selecciona una sucursal">
              <el-option
                v-for="item in branches"
                :key="item.id"
                :label="item.city"
                :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              native-type="submmit">Asignar</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-modal>
  </div>
</template>

<script>
/**
*
* DealerView Component
*
* @author Emmanuel Hernández
* @copyright 2019, Marciano Studio S.C.
*/
import MsGrid from '@/modules/grid/ms-grid'
import MsFormFilter from '@/components/_shared/ms-form-filter'
import DealerGuards from '@/guards/dealer.guards'
import FormModal from '@/components/_shared/form-modal'
export default {
  name: 'DealerView',
  components: { MsGrid, MsFormFilter, FormModal },
  data () {
    return {
      fullscreenLoading: false,
      showModal: false,
      assign: null,
      update: null,
      filters: [
        {
          type: 'string',
          property: 'role',
          props: {
            label: 'Puesto',
            options: [
              {
                label: 'Vendedor',
                value: 'vendedor_dealer'
              },
              {
                label: 'Gerente',
                value: 'gerente_branch'
              }
            ]
          }
        }
      ],
      columns: [
        {
          property: 'firstName',
          label: 'Nombre',
          align: 'center'
        },
        {
          property: 'lastName',
          label: 'Apellidos',
          align: 'center'
        },
        {
          property: 'role',
          label: 'Puesto',
          align: 'center'
        },
        {
          property: 'branch.city',
          label: 'Sucursal',
          align: 'center'
        }
      ],
      options: {
        selectable: false,
        actions: [
          {
            label: 'Asignar',
            icon: 'icon-edit',
            onClick: (row) => {
              this.openModal(row)
            }
          }
        ]
      }
    }
  },
  computed: {
    users () {
      return this.$store.getters['users/items']
    },
    pager () {
      return this.$store.getters['users/pagination']
    },
    branches () {
      return this.$store.getters['branches/items']
    }
  },
  methods: {
    parseRole (role) {
      switch (role) {
        case 'vendedor_dealer':
          return 'Vendedor'
        case 'gerente_branch':
          return 'Gerente de sucursal'
        case 'gerente_dealer':
          return 'Distribuidor'
        default:
          return role
      }
    },
    openModal (row) {
      this.update = row
      this.assign = row.branch ? row.branch.id : null
      this.showModal = true
    },
    onSubmitAssign () {
      this.fullscreenLoading = true
      let clone = Object.assign({}, this.update)
      clone.branchId = this.assign
      this.$store.dispatch('users/save', clone)
        .then(response => {
          this.$message.success('Usuario editado con éxito')
          return this.$store.dispatch('users/query', { ...this.$route.query, with: 'branch,dealer' })
        })
        .catch(e => {
          this.$message.error('No pudo ser editado el cliente')
        })
        .finally(() => {
          this.fullscreenLoading = false
          this.showModal = false
        })
    }
  },
  beforeRouteUpdate: DealerGuards.dealerGuard
}
</script>

<style lang='scss' scoped>
  .dealer-view {
    padding: 30px;
    overflow: auto;
    height: calc(100% - 120px);
    .data {
      h1 {
        @include font-primary(21px, regular);
        color: #707070;
      }
      border-radius: 3px;
      padding: 20px;
      background-color: #fff;
      box-shadow: 0 0 10px rgba(#000, 0.19);
    }
    .modal-content {
      padding: 50px 30px 30px 30px;
      position: relative;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/app/dealer/dealer.view.vue